<template>
  <a class="common-news-cell" href="javascript:void(0)" @click="jumpDetail(newsItem.first_type,newsItem.id)">
    <img :src="newsItem.image_list[0]" alt="" v-if="newsItem.image_list[0]"/>
    <div class="right-wrap">
      <div class="right-top-wrap">
        <p class="common-news-title">{{ newsItem.title }}</p>
        <p class="common-news-content">{{ newsItem.summary }}</p>
      </div>
      <p class="common-news-source">
        {{ newsItem.source }}
      </p>
    </div>
  </a>
</template>

<script>
import UTILS from '../common/utils'
import blankImg from '../common/img/blank.jpg'
export default {
  components: {
  },
  name: 'app',
  props:{
    newsItem: Object
  },
  data(){
    return{
      newsList: [],
      blankImg: blankImg
    }
  },
  mounted() {
    
  },
  methods:{
    jumpDetail(type,id){
      UTILS.fixJumpDetail(type,id)
    }
  }
}
</script>

<style lang="less">
@import '../common/global.less';
.common-news-cell{
  display: flex;
  margin-bottom: 10px;
  padding:30px 0;
  border-bottom: 1px dashed #DDDDDD;
  text-decoration: none;
  &:hover{
    opacity: 1;
    .common-news-title{
      color:#2769e4;
    }
  }
  img{
    flex-shrink: 0;
    width:213px;
    height:132px;
    background:url(../common/img/blank.jpg) top center no-repeat;
    background-size: 100%;
    margin-right:19px;
  }
  .right-wrap{
    display: flex;
    flex-direction: column;
    flex:1;
    
    justify-content: space-between;
    .right-top-wrap{
      .common-news-title{
        .text-lines(1);
        font-size: 18px;
        font-weight: bold;
        margin-bottom:18px;
      }
      .common-news-content{
        .text-lines(3);
        font-size: 14px;
        color:#656565;
      }
    }
    .common-news-source{
      color:#999;
      font-size:14px;
      text-align: right;
    }
  }
}
</style>

